import { Grid } from "@material-ui/core"
import { Elements, Loader } from "@tfo/common"
import classnames from 'classnames'
import * as React from 'react'
import { useIntl } from 'react-intl'
import { useStore } from '../../hooks/useStore'
import ActivateSSO from '../client/views/sso/ActivateSSO'
import UserList from "../client/views/UserList"
import CostsInfo from "../my-account/components/costs-info"


export const MyOrganisation = () => {
	const intl = useIntl()
	const { clientViewStore } = useStore()
	const [contentIndex, setContentIndex] = React.useState(0)
	const { Label } = Elements

	const getContent = () => {

		switch (contentIndex) {
			case 0:
				return (
					<>
						<UserList />
					</>
				)
			case 1:
				return (
					<>
						<CostsInfo companyId={clientViewStore.company.id} />
					</>
				)
			case 2:
				return (
					<>
						{clientViewStore.company.isSSOEnabled && <ActivateSSO />}
					</>
				)
			default:
				return <></>
		}
	}
	return (
		<Grid
			container
			justifyContent="center"
			direction="column"
			className="GridWrapper"
			style={{ marginTop: '2rem' }}>
			<Grid item container direction="row" xs={12}>
				<Grid item xs={6} style={{ padding: '1em' }}>
					<h1 className="Heading1">
						{intl.formatMessage({ id: 'common.myOrganisation' })}
					</h1>
				</Grid>
				<Grid item>
					<div className="ReportsFiltering ReportsFilteringMenu">
						<Label
							className={classnames('ReportsFiltering__Item', {
								'ReportsFiltering__Item--active': contentIndex === 0,
							})}
							onClick={() => setContentIndex(0)}>
							{intl.formatMessage({ id: 'common.myAccount.userHandling' })}
						</Label>


						<Label
							className={classnames('ReportsFiltering__Item', {
								'ReportsFiltering__Item--active': contentIndex === 1,
							})}
							onClick={() => setContentIndex(1)}>
							{intl.formatMessage({ id: 'common.myAccount.costs' })}
						</Label>
						{clientViewStore.company.isSSOEnabled &&
							<Label
								className={classnames('ReportsFiltering__Item', {
									'ReportsFiltering__Item--active': contentIndex === 2,
								})}
								onClick={() => setContentIndex(2)}>
								{intl.formatMessage({ id: 'common.sso' })}
							</Label>
						}
					</div>
				</Grid>
			</Grid>
			{getContent()}
			{clientViewStore.loading && <Loader />}

		</Grid>

	)
}
